<template>
    <div class="riskFactors">
      <i class="iconfont iconfanhui back" @click.stop="$router.back()">返回</i>
      <div class="riskFactors_wrap">
        <div class="riskFactors_box">
          <p class="title">在我国，高血脂、高血压、吸烟、糖尿病和肥胖是导致冠心病和急性心肌梗死等心血管疾病最重要的5个危险因素。</p>
          <div class="list">
            <div class="list_title">
              <img src="../../assets/images/ceramide/blood.png" alt="血脂异常">
              <p>血脂异常</p>
            </div>
            <div class="word">
              血清甘油三酯水平轻至中度、神经酰胺水平高
              者患冠心病危险性增加。低密度脂蛋白胆固醇增
              高是动脉粥样硬化的主要危险因素。
            </div>
          </div>
          <div class="list">
            <div class="list_title">
              <img src="../../assets/images/ceramide/overweight.png" alt="超重肥胖">
              <p>超重肥胖</p>
            </div>
            <div class="word">
              BMI≥24者患高血压的危险是体重正常者的3-4倍，患糖尿病的危险是体重正常者的2-3倍。
            </div>
          </div>
          <div class="list">
            <div class="list_title">
              <img src="../../assets/images/ceramide/pressure.png" alt="血压异常">
              <p>血压异常</p>
            </div>
            <div class="word">
              在主动脉、脑动脉和冠状动脉，由于持续的高动脉压，内膜对血浆脂蛋白通透性增加，胆固醇易于在内膜下沉积，形成动脉粥样硬化。高血压心是血管病非常重要的危险因素。
            </div>
          </div>
          <div class="list">
            <div class="list_title">
              <img src="../../assets/images/ceramide/glucose.png" alt="空腹血糖异常">
              <p>空腹血糖异常</p>
            </div>
            <div class="word">
              糖尿病并发症危害大，其并发症主要有高血压、脑血管病、心血管病等。
            </div>
          </div>
          <div class="list">
            <div class="list_title">
              <img src="../../assets/images/ceramide/smoke.png" alt="吸烟及二手烟">
              <p>吸烟及二手烟</p>
            </div>
            <div class="word">
              吸烟是引发高血脂的头号“罪犯”。吸烟时吸入尼古丁、一氧化碳、烟碱。一氧化碳与血红蛋白结合形成碳氧血红蛋白，其增高引起机体缺氧，动脉壁缺氧、水肿，血流障碍，内皮受损，为 胆固醇在血管壁上沉积创造条件。同时，缺氧促 进平滑肌细胞摄取低密度脂蛋白胆固醇，促使动 脉发生粥样硬化。
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'riskFactors'
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .riskFactors {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .riskFactors_wrap {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .riskFactors_box {
        padding: pxToRem(80px);
        background: #fff;
        border-radius: pxToRem(20px);

        .title {
          font-size: pxToRem(24px);
          color: #2A6BAE;
          text-indent: 1em;
          letter-spacing: 1px;
          margin-bottom: pxToRem(53px);
        }

        .list {
          margin-bottom: pxToRem(60px);

          .list_title {
            display: flex;
            align-items: center;
            margin-bottom: pxToRem(20px);
            img {
              width: pxToRem(70px);
              height: pxToRem(70px);
            }
            p {
              font-size: pxToRem(31px);
              font-weight: 400;
              color: #2A6BAE;
              margin-left: pxToRem(20px);
            }
          }

          .word {
            font-size: pxToRem(24px);
            font-weight: 400;
            text-indent: 1em;
            letter-spacing: 1px;
            text-align: justify;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/riskFactors.vue